import { Hackerrank } from '@/assets/icons/ats';
import { Gmeet, Teams, Zoom } from '@/assets/icons/location';
import { v4 as uuidv4 } from 'uuid';

export const getMissingFieldsMessage = (obj) => {
  const fields = Object.entries(obj)
    .filter(([, value]) => value)
    .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1));

  switch (fields.length) {
    case 0:
      return '';
    case 1:
      return `Required fields missing validation in ${fields[0]}`;
    default: {
      const lastField = fields.pop();
      return `Required fields missing in ${fields.join(', ')} and ${lastField}`;
    }
  }
};

export const checkIfAnyFieldTrue = (obj) => {
  for (const key in obj) {
    if (obj[key] === true) {
      return true;
    }
  }
  return false;
};

export const getInterviewRadio = (value) => {
  if (value === 'manual_selection') {
    return { interview_pool: false, manual_selection: true };
  } else if (value === 'interview_pool') {
    return { interview_pool: true, manual_selection: false };
  } else {
    return null;
  }
};

export const getInterviewRadioValue = (option) => {
  if (option.interview_pool === true) {
    return 'interview_pool';
  } else if (option.manual_selection === true) {
    return 'manual_selection';
  } else {
    return null;
  }
};

export const getDetailsPayload = (values, stage, planData = {}) => {
  const {
    interview_type,
    interviewName,
    interviewTypeRadio,
    participant_ids,
    interview_pool_id,
    duration,
    schedule_selection,
    location,
    office = '',
    enable_note_taker,
    ext_interview_template_id,
    fill_with_ai_enabled,
  } = values;
  const interviewRadioValues = getInterviewRadio(interviewTypeRadio);
  const payload = {
    label: interviewName,
    interview_type: interview_type,
    duration,
    schedule_selection: schedule_selection,
    location,
    note_taker_enabled:
      enable_note_taker || planData?.note_taker_mandatory || false,
    fill_with_ai_enabled: fill_with_ai_enabled ?? false,
    ...interviewRadioValues,
  };
  if (office && location === 'onsite') {
    payload.office_id = office;
  }

  if (
    participant_ids?.length &&
    ((interview_type === 'one_on_one' &&
      interviewTypeRadio !== 'interview_pool') ||
      interview_type === 'panel')
  ) {
    payload.participant_ids = participant_ids;
  } else {
    payload.participant_ids = [];
  }
  if (
    interview_pool_id &&
    interviewTypeRadio === 'interview_pool' &&
    interview_type === 'one_on_one'
  ) {
    payload.interview_pool_id = interview_pool_id;
  } else {
    payload.interview_pool = false;
  }

  if (ext_interview_template_id) {
    payload.ext_interview_template_id = ext_interview_template_id;
  }

  return payload;
};

export const getScorecardPayload = (scorecards = []) => {
  return scorecards?.map((scorecard) => {
    const payload = {
      question: scorecard?.question,
      type: scorecard?.type,
      mandatory: scorecard?.mandatory || false,
      description: scorecard?.description || '',
    };
    if (scorecard?.options?.length) {
      payload.options = scorecard?.options?.map((option) => option?.optionText);
    }
    return payload;
  });
};

export const getScorecardInitialValues = (scorecards = []) => {
  return scorecards?.map((scorecard) => {
    const payload = {
      id: uuidv4(),
      question: scorecard?.question,
      type: scorecard?.type,
      mandatory: scorecard?.mandatory,
      description: scorecard?.description,
    };
    if (scorecard?.options?.length) {
      payload.options = scorecard?.options?.map((option) => ({
        optionText: option,
      }));
    }
    return payload;
  });
};

export const locationValuemap = {
  zoom: 'Zoom',
  google_meet: 'Google Meet',
  teams: 'MS teams',
  phone_interview: 'Phone Interview',
  onsite: 'Onsite',
  hackerrank: 'HackerRank',
};

export const locationIconmap = {
  zoom: Zoom,
  google_meet: Gmeet,
  teams: Teams,
  hackerrank: Hackerrank,
};

export const interviewTypeValueMap = {
  one_on_one: '1 to 1 Interview',
  panel: 'Group interview',
};
